import React from 'react';
import { theme } from '../styles/theme';

const PrivacyPolicy = () => {
  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: theme.colors.background,
      color: theme.colors.text,
      fontFamily: theme.typography.fontFamily,
    },
    hero: {
      background: `linear-gradient(135deg, ${theme.colors.primary} 0%, #005a9f 100%)`,
      padding: '100px 20px',
      textAlign: 'center',
      color: 'white',
      position: 'relative',
      overflow: 'hidden',
    },
    heroPattern: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M20 20c0 11.046-8.954 20-20 20v20h40V20H20z'/%3E%3C/g%3E%3C/svg%3E")`,
      opacity: 0.15,
    },
    heroContent: {
      position: 'relative',
      zIndex: 2,
      maxWidth: '900px',
      margin: '0 auto',
    },
    heroTitle: {
      fontSize: '4rem',
      fontWeight: '900',
      marginBottom: '24px',
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      textTransform: 'uppercase',
      letterSpacing: '3px',
      textShadow: '3px 3px 6px rgba(0,0,0,0.4)',
      lineHeight: '1.1',
    },
    heroSubtitle: {
      fontSize: '1.5rem',
      opacity: 0.95,
      maxWidth: '700px',
      margin: '0 auto 32px auto',
      lineHeight: '1.7',
      fontWeight: '400',
    },
    terminalBadge: {
      display: 'inline-block',
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      border: '2px solid rgba(255,255,255,0.4)',
      padding: '12px 24px',
      borderRadius: '8px',
      textTransform: 'uppercase',
      letterSpacing: '2px',
      fontSize: '1rem',
      fontWeight: '700',
      background: 'rgba(255,255,255,0.1)',
      backdropFilter: 'blur(10px)',
    },
    content: {
      maxWidth: '1000px',
      margin: '0 auto',
      padding: '80px 20px',
    },
    effectiveDate: {
      backgroundColor: '#f8f9fa',
      padding: '24px',
      borderRadius: '12px',
      border: `3px solid ${theme.colors.primary}`,
      marginBottom: '60px',
      textAlign: 'center',
      position: 'relative',
      overflow: 'hidden',
    },
    effectiveDatePattern: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23007acc' fill-opacity='0.05'%3E%3Cpath d='M0 0h20v20H0z'/%3E%3C/g%3E%3C/svg%3E")`,
    },
    effectiveDateContent: {
      position: 'relative',
      zIndex: 2,
    },
    effectiveDateText: {
      fontSize: '1.2rem',
      fontWeight: '700',
      color: theme.colors.primary,
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      textTransform: 'uppercase',
      letterSpacing: '1.5px',
    },
    section: {
      marginBottom: '60px',
      backgroundColor: 'white',
      borderRadius: '16px',
      padding: '50px',
      border: `3px solid ${theme.colors.primary}`,
      boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
      position: 'relative',
      overflow: 'hidden',
    },
    sectionGlow: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `linear-gradient(45deg, transparent 0%, ${theme.colors.primary}05 50%, transparent 100%)`,
      pointerEvents: 'none',
    },
    sectionContent: {
      position: 'relative',
      zIndex: 2,
    },
    sectionTitle: {
      fontSize: '2.2rem',
      fontWeight: '900',
      color: theme.colors.primary,
      marginBottom: '32px',
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      textTransform: 'uppercase',
      letterSpacing: '2px',
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      borderBottom: `3px solid ${theme.colors.primary}`,
      paddingBottom: '16px',
    },
    sectionNumber: {
      fontSize: '1.8rem',
      fontWeight: '900',
      color: 'white',
      backgroundColor: theme.colors.primary,
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      minWidth: '60px',
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '8px',
      textShadow: 'none',
    },
    subsectionTitle: {
      fontSize: '1.4rem',
      fontWeight: '700',
      color: theme.colors.text,
      marginTop: '40px',
      marginBottom: '20px',
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      textTransform: 'uppercase',
      letterSpacing: '1px',
      position: 'relative',
      paddingLeft: '25px',
    },
    subsectionBracket: {
      position: 'absolute',
      left: '0',
      top: '0',
      color: theme.colors.primary,
      fontWeight: '900',
      fontSize: '1.6rem',
    },
    paragraph: {
      marginBottom: '24px',
      fontSize: '1.1rem',
      lineHeight: '1.8',
      color: theme.colors.textLight,
    },
    strongText: {
      fontWeight: '700',
      color: theme.colors.text,
    },
    list: {
      paddingLeft: '0',
      marginBottom: '32px',
      listStyle: 'none',
    },
    listItem: {
      marginBottom: '16px',
      fontSize: '1.1rem',
      lineHeight: '1.7',
      color: theme.colors.textLight,
      paddingLeft: '35px',
      position: 'relative',
    },
    listBullet: {
      position: 'absolute',
      left: '0',
      top: '0',
      color: theme.colors.primary,
      fontWeight: '900',
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      fontSize: '1.2rem',
    },
    highlight: {
      backgroundColor: `${theme.colors.primary}15`,
      padding: '32px',
      borderRadius: '12px',
      marginBottom: '40px',
      border: `3px solid ${theme.colors.primary}`,
      position: 'relative',
      overflow: 'hidden',
    },
    highlightPattern: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='30' height='30' viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23007acc' fill-opacity='0.1'%3E%3Cpath d='M15 0v30M0 15h30'/%3E%3C/g%3E%3C/svg%3E")`,
    },
    highlightContent: {
      position: 'relative',
      zIndex: 2,
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      marginBottom: '40px',
      border: `3px solid ${theme.colors.primary}`,
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
    },
    tableHeader: {
      backgroundColor: theme.colors.primary,
      color: 'white',
      padding: '20px',
      textAlign: 'left',
      fontWeight: '900',
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      textTransform: 'uppercase',
      letterSpacing: '1px',
      fontSize: '1rem',
    },
    tableCell: {
      padding: '20px',
      borderBottom: `2px solid ${theme.colors.primary}30`,
      color: theme.colors.textLight,
      verticalAlign: 'top',
      fontSize: '1rem',
      lineHeight: '1.6',
    },
    tableRowEven: {
      backgroundColor: '#f8f9fa',
    },
    contact: {
      background: `linear-gradient(135deg, ${theme.colors.primary} 0%, #005a9f 100%)`,
      color: 'white',
      padding: '60px',
      borderRadius: '16px',
      textAlign: 'center',
      marginTop: '80px',
      position: 'relative',
      overflow: 'hidden',
    },
    contactPattern: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='50' height='50' viewBox='0 0 50 50' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M25 25c0 13.807-11.193 25-25 25v25h50V25H25z'/%3E%3C/g%3E%3C/svg%3E")`,
    },
    contactContent: {
      position: 'relative',
      zIndex: 2,
    },
    contactTitle: {
      fontSize: '2.5rem',
      fontWeight: '900',
      marginBottom: '24px',
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      textTransform: 'uppercase',
      letterSpacing: '2px',
      textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
    },
    contactInfo: {
      fontSize: '1.3rem',
      marginBottom: '16px',
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      letterSpacing: '1px',
    },
    contactEmail: {
      color: 'white',
      textDecoration: 'none',
      fontWeight: '700',
      border: '2px solid rgba(255,255,255,0.3)',
      padding: '12px 24px',
      borderRadius: '8px',
      display: 'inline-block',
      marginTop: '16px',
      transition: 'all 0.3s ease',
      backgroundColor: 'rgba(255,255,255,0.1)',
      backdropFilter: 'blur(10px)',
      textTransform: 'uppercase',
      letterSpacing: '1px',
    },
    // Responsive styles
    '@media (max-width: 768px)': {
      heroTitle: {
        fontSize: '2.5rem',
      },
      section: {
        padding: '30px',
        marginBottom: '40px',
      },
      sectionTitle: {
        fontSize: '1.8rem',
      },
      content: {
        padding: '40px 15px',
      },
    },
  };

  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div style={styles.container}>
      {/* Enhanced Hero Section */}
      <div style={styles.hero}>
        <div style={styles.heroPattern}></div>
        <div style={styles.heroContent}>
          <h1 style={styles.heroTitle}>[PRIVACY_POLICY]</h1>
          <p style={styles.heroSubtitle}>
            Your privacy and data security are fundamental to ByteBot's mission. 
            This comprehensive policy explains how we protect, process, and respect your information 
            with complete transparency and industry-leading security standards.
          </p>
          <div style={styles.terminalBadge}>
            [LAST_UPDATED: {currentDate}]
          </div>
        </div>
      </div>

      <div style={styles.content}>
        {/* Enhanced Effective Date */}
        <div style={styles.effectiveDate}>
          <div style={styles.effectiveDatePattern}></div>
          <div style={styles.effectiveDateContent}>
            <div style={styles.effectiveDateText}>
              [EFFECTIVE_DATE: {currentDate} | VERSION_3.0]
            </div>
          </div>
        </div>

        {/* Introduction */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>01</span>
              [INTRODUCTION]
            </h2>
            <div style={styles.highlight}>
              <div style={styles.highlightPattern}></div>
              <div style={styles.highlightContent}>
                <p><span style={styles.strongText}>[PRIVACY_COMMITMENT]</span> - ByteBot ("we," "us," or "our") is committed to protecting your privacy and personal data. This Privacy Policy explains how we collect, use, share, and safeguard your information when you use our AI chatbot platform and related services.</p>
              </div>
            </div>
            <p style={styles.paragraph}>
              This policy applies to all users of ByteBot's services, including our website, 
              AI chatbot builder platform, embedded chat widgets, and any related applications or services we provide. 
              By using our services, you agree to the collection and use of information in accordance with this policy.
            </p>
            <p style={styles.paragraph}>
              <span style={styles.strongText}>Key Definitions:</span> "Personal Data" means any information relating to an identified or identifiable person. 
              "Processing" means any operation performed on personal data. "Services" refers to ByteBot's AI chatbot platform, 
              ByteBot Builder, knowledge base management, conversation analytics, and embedded chat widgets.
            </p>
          </div>
        </div>

        {/* Information We Collect */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>02</span>
              [DATA_COLLECTION]
            </h2>
            
            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>ACCOUNT_INFORMATION]
            </h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Registration Data:</span> Email address, name, company information, and account preferences when you create a ByteBot account
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Authentication:</span> Secure login credentials and authentication tokens managed through Firebase Authentication
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Profile Settings:</span> Business type, industry information, chatbot customization preferences, and dashboard settings
              </li>
            </ul>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>CHATBOT_DATA]
            </h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Conversation Logs:</span> All interactions between your customers and your ByteBot chatbots, including messages, timestamps, and conversation metadata
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Knowledge Base Content:</span> Business information, FAQs, policies, and any content you upload to train your chatbot
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Bot Configurations:</span> System prompts, personality settings, response templates, and customization data created through ByteBot Builder
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Widget Settings:</span> Appearance, positioning, and behavioral settings for embedded chat widgets
              </li>
            </ul>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>USAGE_ANALYTICS]
            </h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Platform Usage:</span> Feature usage patterns, session duration, dashboard interactions, and platform performance metrics
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Conversation Metrics:</span> Number of conversations, response times, conversation length, and customer satisfaction indicators
              </li>
              <li style={styles.listItem}>
                <span style={styles.strongText}>Technical Data:</span> IP addresses, browser type, device information, operating system, and referral sources
              </li>
            </ul>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>PAYMENT_DATA]
            </h3>
            <p style={styles.paragraph}>
              Payment information is processed securely through Stripe, our payment processor. 
              We do not store credit card information on our servers. We only retain billing history, 
              subscription status, and transaction IDs necessary for account management and customer support.
            </p>
          </div>
        </div>

        {/* How We Use Your Information */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>03</span>
              [DATA_USAGE]
            </h2>
            
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.tableHeader}>[PURPOSE]</th>
                  <th style={styles.tableHeader}>[DATA_USED]</th>
                  <th style={styles.tableHeader}>[LEGAL_BASIS]</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={styles.tableCell}>Provide ByteBot chatbot services</td>
                  <td style={styles.tableCell}>Account data, conversations, bot configurations, knowledge base content</td>
                  <td style={styles.tableCell}>Contract performance</td>
                </tr>
                <tr style={styles.tableRowEven}>
                  <td style={styles.tableCell}>Process payments and manage subscriptions</td>
                  <td style={styles.tableCell}>Billing information, subscription status, usage metrics</td>
                  <td style={styles.tableCell}>Contract performance</td>
                </tr>
                <tr>
                  <td style={styles.tableCell}>Improve AI models and platform features</td>
                  <td style={styles.tableCell}>Anonymized conversation patterns, usage analytics</td>
                  <td style={styles.tableCell}>Legitimate interest</td>
                </tr>
                <tr style={styles.tableRowEven}>
                  <td style={styles.tableCell}>Provide customer support</td>
                  <td style={styles.tableCell}>Account information, usage data, support communications</td>
                  <td style={styles.tableCell}>Contract performance</td>
                </tr>
                <tr>
                  <td style={styles.tableCell}>Security monitoring and fraud prevention</td>
                  <td style={styles.tableCell}>Access logs, usage patterns, IP addresses, authentication data</td>
                  <td style={styles.tableCell}>Legitimate interest</td>
                </tr>
                <tr style={styles.tableRowEven}>
                  <td style={styles.tableCell}>Legal compliance and regulatory requirements</td>
                  <td style={styles.tableCell}>All relevant data as required by applicable laws</td>
                  <td style={styles.tableCell}>Legal obligation</td>
                </tr>
                <tr>
                  <td style={styles.tableCell}>Platform analytics and optimization</td>
                  <td style={styles.tableCell}>Usage metrics, performance data, feature adoption statistics</td>
                  <td style={styles.tableCell}>Legitimate interest</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Data Sharing and Third Parties */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>04</span>
              [DATA_SHARING]
            </h2>
            
            <div style={styles.highlight}>
              <div style={styles.highlightPattern}></div>
              <div style={styles.highlightContent}>
                <p><span style={styles.strongText}>[NO_SALE_POLICY]</span> - ByteBot does not sell, rent, or trade your personal information to third parties for marketing purposes. Your data is yours, and we respect that.</p>
              </div>
            </div>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>AUTHORIZED_SHARING]
            </h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Service Providers:</span> We share data with trusted partners who help us provide ByteBot services:
                <ul style={{...styles.list, marginTop: '12px', paddingLeft: '20px'}}>
                  <li style={styles.listItem}><span style={styles.strongText}>Firebase/Google Cloud:</span> Infrastructure, database, and authentication services</li>
                  <li style={styles.listItem}><span style={styles.strongText}>OpenAI:</span> AI processing for chatbot conversations (data is not used to train OpenAI models)</li>
                  <li style={styles.listItem}><span style={styles.strongText}>Stripe:</span> Payment processing and subscription management</li>
                </ul>
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Legal Requirements:</span> We may disclose information when required by law, court order, or to protect our rights and safety
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Business Transfers:</span> In the event of a merger, acquisition, or sale, data may be transferred as part of business assets
              </li>
            </ul>
          </div>
        </div>

        {/* Data Security */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>05</span>
              [SECURITY_MEASURES]
            </h2>

            <p style={styles.paragraph}>
              ByteBot implements enterprise-grade security measures to protect your data:
            </p>

            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Encryption:</span> All data is encrypted in transit using TLS 1.3 and at rest using AES-256 encryption
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Access Controls:</span> Multi-factor authentication, role-based access controls, and principle of least privilege
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Infrastructure Security:</span> Google Cloud Platform's enterprise-grade security, regular security audits, and compliance monitoring
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Data Isolation:</span> Strict database security rules ensure users can only access their own data
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Monitoring:</span> 24/7 security monitoring, automated threat detection, and incident response procedures
              </li>
            </ul>
          </div>
        </div>

        {/* Your Rights */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>06</span>
              [YOUR_RIGHTS]
            </h2>

            <p style={styles.paragraph}>
              You have comprehensive rights regarding your personal data. Contact us to exercise any of these rights:
            </p>

            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Access:</span> Request a copy of your personal data we process
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Rectification:</span> Correct inaccurate or incomplete personal data
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Deletion:</span> Request deletion of your personal data (subject to legal obligations)
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Portability:</span> Receive your data in a structured, machine-readable format
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Restriction:</span> Limit how we process your personal data
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Objection:</span> Object to processing based on legitimate interests
              </li>
            </ul>

            <p style={styles.paragraph}>
              <span style={styles.strongText}>Data Retention:</span> We retain your data for as long as necessary to provide services and comply with legal obligations. 
              Conversation logs are retained for 2 years for service improvement and support purposes. 
              Account data is retained until account deletion, after which it's permanently removed within 30 days.
            </p>
          </div>
        </div>

        {/* Cookies and Tracking */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>07</span>
              [COOKIES_TRACKING]
            </h2>

            <p style={styles.paragraph}>
              ByteBot uses cookies and similar technologies to enhance your experience:
            </p>

            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.tableHeader}>[COOKIE_TYPE]</th>
                  <th style={styles.tableHeader}>[PURPOSE]</th>
                  <th style={styles.tableHeader}>[DURATION]</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={styles.tableCell}>Essential Cookies</td>
                  <td style={styles.tableCell}>Authentication, security, basic functionality</td>
                  <td style={styles.tableCell}>Session/30 days</td>
                </tr>
                <tr style={styles.tableRowEven}>
                  <td style={styles.tableCell}>Analytics Cookies</td>
                  <td style={styles.tableCell}>Usage statistics, performance monitoring, feature optimization</td>
                  <td style={styles.tableCell}>1-2 years</td>
                </tr>
                <tr>
                  <td style={styles.tableCell}>Preference Cookies</td>
                  <td style={styles.tableCell}>Dashboard settings, UI preferences, personalization</td>
                  <td style={styles.tableCell}>1 year</td>
                </tr>
              </tbody>
            </table>

            <p style={styles.paragraph}>
              You can control cookies through your browser settings. Disabling essential cookies may impact platform functionality.
            </p>
          </div>
        </div>

        {/* International Transfers */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>08</span>
              [INTERNATIONAL_TRANSFERS]
            </h2>

            <p style={styles.paragraph}>
              ByteBot operates globally using cloud infrastructure. Your data may be processed in countries other than your own, 
              including the United States where our primary servers are located. We ensure adequate protection through:
            </p>

            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Adequacy Decisions:</span> Transfers to countries with adequate data protection
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Standard Contractual Clauses:</span> EU-approved contractual safeguards
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Encryption:</span> End-to-end encryption for all data transfers
              </li>
            </ul>
          </div>
        </div>

        {/* Children's Privacy */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>09</span>
              [CHILDREN_PRIVACY]
            </h2>

            <p style={styles.paragraph}>
              ByteBot is designed for business use and is not intended for children under 13 years of age. 
              We do not knowingly collect personal information from children under 13. 
              If you become aware that a child has provided us with personal data, please contact us immediately, 
              and we will take steps to remove such information and terminate the child's account.
            </p>
          </div>
        </div>

        {/* Changes to Privacy Policy */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>10</span>
              [POLICY_UPDATES]
            </h2>

            <p style={styles.paragraph}>
              We may update this Privacy Policy periodically to reflect changes in our practices, 
              technology, legal requirements, or other factors. We will notify you of significant changes through:
            </p>

            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Email Notification:</span> Direct notice to your registered email address
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Platform Notice:</span> In-app notifications and dashboard alerts
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Website Banner:</span> Prominent notice on our website
              </li>
            </ul>

            <p style={styles.paragraph}>
              Continued use of ByteBot after policy changes constitutes acceptance of the updated terms.
            </p>
          </div>
        </div>

        {/* Enhanced Contact Section */}
        <div style={styles.contact}>
          <div style={styles.contactPattern}></div>
          <div style={styles.contactContent}>
            <h2 style={styles.contactTitle}>[PRIVACY_SUPPORT]</h2>
            <p style={styles.contactInfo}>
              Questions about this Privacy Policy or your data rights?
            </p>
            <p style={styles.contactInfo}>
              Our privacy team is here to help.
            </p>
            <a 
              href="/contact" 
              style={styles.contactEmail}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'rgba(255,255,255,0.2)';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              [CONTACT_SUPPORT]
            </a>
            <div style={{marginTop: '32px', fontSize: '1.1rem', opacity: '0.9'}}>
              <div>Data Protection Officer: ByteBot Privacy Team</div>
              <div>Response Time: Within 30 days (typically within 5 business days)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 